export enum BenefitType {
  BENEFIT = 'BENEFIT',
  SPORT = 'SPORT'
}
